<template>
  <div>
    <div v-if="code == true" class="item_font">
      <el-dialog
        title="智能客服-重置密码"
        :visible.sync="code_p"
        @close="close"
        class="tanchuang"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="item_font">
          您正在对<span style="font-weight: bold">{{ userName }}</span
          >账号进行重置密码的操作，请先进行安全验证：
        </div>
        <div style="margin-top: 50px; margin-bottom: 12px" class="item_font">
          点击获取验证码，短信将发送至账户绑定手机<span
            style="font-weight: bold"
            >{{ phoneNumber }}</span
          >
        </div>
        <el-form :model="codeForm">
          <el-input
            v-model="codeForm.code"
            ref="code"
            autocomplete="off"
            placeholder="请输入验证码"
            style="width: 250px"
          ></el-input>
          <el-button
            style="margin-left: 20px"
            :disabled="isDisabled"
            @click="getSMScode"
            class="item_font"
            >{{ buttonName }}</el-button
          >
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clickCancle('code')" class="item_font"
            >取 消</el-button
          >
          <el-button
            type="primary"
            :disabled="!codeForm.code"
            @click="confirm(1)"
            class="item_font"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div v-if="password == true" class="item_font">
      <el-dialog
        title="智能客服-重置密码"
        :visible.sync="password"
        @close="close"
        class="tanchuang"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="passwordForm" :rules="rules">
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              line-height: 40px;
            "
          >
            <div style="width: 200px; text-align: left" class="item_font">
              请输入新密码
            </div>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model.trim="passwordForm.password"
                autocomplete="off"
                style="width: 250px"
                @keyup.enter.native="nextInputps(5)"
              ></el-input>
            </el-form-item>
            <div style="width: 200px; text-align: left" class="item_font">
              再次确认输入
            </div>
            <el-form-item prop="passwordCheck">
              <el-input
                type="password"
                v-model.trim="passwordForm.passwordCheck"
                autocomplete="off"
                style="width: 250px"
                @keyup.enter.native="nextInputps(4)"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clickCancle('password')" class="item_font"
            >取 消</el-button
          >
          <el-button
            type="primary"
            :disabled="psdDisabled"
            @click="confirm(2)"
            class="item_font"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div v-if="showSuccess == true" class="item_font">
      <el-dialog
        title="智能客服-密码修改成功提示"
        :visible.sync="success"
        @close="close"
        class="tanchuang"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="item_font">密码修改成功，请重新登录</div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clickCancle('showSuccess')" class="item_font"
            >取 消</el-button
          >
          <el-button type="primary" @click="confirm(3)" class="item_font"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  name: "FG-password",
  props: ["userName", "phoneNumber", "code", "password", "showSuccess"],
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (
        this.passwordForm.password.length < 6 ||
        this.passwordForm.password.length > 12
      ) {
        callback(new Error("请输入长度为6-12位的密码！"));
      }
      // else {
      //   if (this.passwordForm.passwordCheck != "") {
      //     this.$refs.passwordForm.validateField("passwordCheck");
      //   }
      //   callback();
      // }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (
        this.passwordForm.passwordCheck.length < 6 ||
        this.passwordForm.passwordCheck.length > 12
      ) {
        callback(new Error("请输入长度为6-12位的密码！"));
      } else if (value != this.passwordForm.passwordCheck) {
        callback(new Error("两次输入密码不一致！"));
      } else {
        this.psdDisabled = false;
        callback();
      }
    };
    return {
      code_p: this.code,
      isDisabled: false,
      buttonName: "发送验证码",
      psdDisabled: true,
      time: 60,
      // code: true,
      // editPassword:this.password,
      success: false,
      codeForm: {
        code: "",
      },
      passwordForm: {
        password: "",
        passwordCheck: "",
      },
      rules: {
        password: [
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
        passwordCheck: [
          {
            validator: validatePass2,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    async confirm(num) {
      var SMScode = this.codeForm.code;
      console.log("confirmNum", num);
      if (num == 1) {
        // this.password = true
        var codeApi = "/manager/user/pass/checkCode";
        const response = await this.util.postRequest({
          url: codeApi,
          method: "POST",
          data: {
            loginName: this.userName,
            captcha: SMScode,
            // password: this.passwordForm.password
          },
        });
        console.log("Login CheckCode response=", response);
        console.log("response.resultCode=", response.resultCode);
        if (response.resultCode === "10000") {
          // this.editPassword = true
          // this.$emit('clickCancle',{value:true,type:"password"})
          this.$emit("confirm", 1);
        } else {
          // this.$message.error(response.desc)
          // this.code = true
          // this.codeForm.code = ""
          this.$message.error(response.desc);
          // this.$emit('clickCancle',{value:true,type:"code"})

          // this.code = false
        }
      } else if (num == 2) {
        // this.editPassword = false
        if (this.passwordForm.password === this.passwordForm.passwordCheck) {
          var editpsdApi = "/manager/user/pass/checkCodeAndEditPassword";
          const response = await this.util.postRequest({
            url: editpsdApi,
            method: "POST",
            data: {
              loginName: this.userName,
              captcha: SMScode,
              // 密码加密
              password: md5(this.passwordForm.password.trim()),
            },
          });
          console.log("Login CheckCode response=", response);
          if (response.resultCode === "10000") {
            this.success = true;
            this.$emit("confirm", 2);
          } else {
            this.$message.error(response.desc);
            // this.code = true
            // this.codeForm.code = ""
            // this.success = true
            // this.$emit('confirm', 2)
          }
        } else {
          this.$message.error("两次输入的密码不一致，请重新输入！");
        }
      } else {
        this.$emit("confirm", 3);
        // this.success = false
        // this.code = true
      }
    },
    close() {
      this.codeForm.code = "";
      this.$emit("close", "");
      // this.code = true;
    },
    async getSMScode() {
      let that = this;
      that.isDisabled = true;
      let interval = window.setInterval(function () {
        that.buttonName = that.time + "秒后重新发送";
        --that.time;
        if (that.time < 0) {
          that.buttonName = "重新发送验证码";
          that.time = 60;
          that.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);

      console.log(that.phoneNumber, that.userName);
      that.$refs.code.focus();
      console.log("login getSMScode name = ", name);
      var api = "/manager/user/pass/forgerSMS";
      const response = await that.util.postRequest({
        url: api,
        method: "POST",
        data: {
          loginName: that.userName,
        },
      });
      if (response.resultCode === "10000") {
        console.log(111);
      } else {
        this.$message.error(response.desc);
      }
      console.log("Login getSMScode response = ", response);
    },
    nextInputps(num) {
      var inputs = document.getElementsByTagName("input");
      console.log(inputs);
      inputs[num].focus();
    },
    clickCancle(type) {
      // this.codeForm.code=""
      this.passwordForm.password = "";
      this.passwordForm.passwordCheck = "";
      this.$emit("clickCancle", { value: false, type: type });
    },
  },
};
</script>

<style>
.tanchuang {
  height: 600px;
}

.input {
  width: 100px;
  background-color: #000080;
}
</style>
